var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bim-tag",class:[
  {
    'hover-effect': !_vm.nohover,
  },
  ]},[_c('span',{staticClass:"bim-tag__text",style:({
      fontSize: _vm.fontSize
    })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }